<template>
  <div :class="componentClasses">
    <Icon
      v-if="iconBefore"
      :icon="iconBefore"
    />
    <div class="stk-callout-body">
      <Title
        v-if="title"
        size="5"
        class="stk-callout-title"
      >
        {{ title }}
      </Title>
      <slot />
    </div>
    <Icon
      v-if="iconAfter"
      :icon="iconAfter"
    />
    <slot name="after" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Title from '@stakeui/content/text/Title.vue';
import Icon from '@stakeui/graphic/icon/Icon.vue';

const props = defineProps({
  status: String,
  iconBefore: String,
  iconAfter: String,
  size: String,
  bold: Boolean,
  title: String,
  spacing: String,
  variant: String,
});

const componentClasses = computed(() => [
  'stk-callout',
  { [`is-${props.status}`]: props.status },
  { [`variant-${props.variant}`]: props.variant },
  props.bold && `is-bold`,
  props.size ? `stk-size-${props.size}` : '',
  props.spacing ? `spacing-${props.spacing}` : '',
]);
</script>

<style>
.stk-callout {
  --background-color: var(--stk-text-95);
  --color: var(--stk-text-30);
  background-color: var(--background-color);
  color: var(--color);
  display: flex;
  align-items: start;
  justify-content: flex-start;
  font-weight: 600;
  line-height: 1.25;
  padding: 0.5em 0.75em;
  border-radius: 0.75em;
  gap: 0.5em;

  &.is-primary {
    --background-color: var(--stk-primary-90);
    --color: var(--stk-primary-30);

    &.is-bold {
      --color: var(--stk-primary-100);
      --background-color: var(--stk-primary-50);
    }
  }

  &.is-success {
    --background-color: var(--stk-success-90);
    --color: var(--stk-success-30);

    &.is-bold {
      --color: var(--stk-success-100);
      --background-color: var(--stk-success-30);
    }
  }

  &.is-info {
    --background-color: var(--stk-info-95);
    --color: var(--stk-info-30);

    &.is-bold {
      --color: var(--stk-info-100);
      --background-color: var(--stk-info-30);
    }
  }

  &.is-warning {
    --background-color: var(--stk-warning-90);
    --color: var(--stk-warning-30);

    &.is-bold {
      --color: var(--stk-warning-100);
      --background-color: var(--stk-warning-30);
    }
  }

  &.is-danger {
    --background-color: var(--stk-danger-90);
    --color: var(--stk-danger-30);

    &.is-bold {
      --color: var(--stk-danger-100);
      --background-color: var(--stk-danger-30);
    }
  }

  &.variant-empty {
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: 3em;
  }

  &.spacing-loose {
    padding: 1em 1.25em;
  }
}

.stk-callout-body {
  font-weight: 500;
  flex-grow: 1;
}

.stk-callout-title {
  color: inherit;
}
</style>
